import http from "../http-common";

class AdminDataService {
  getAll() {
    return http.get("/admin/users");
  }

  get(id) {
    return http.get(`/admin/users/${id}`);
  }


}

export default new AdminDataService();